import API from '@/services/api'

// Actions
export const FETCH_DISK_USAGE = 'fetchDiskUsage'
export const FETCH_INSPECTION_STATUS = 'fetchInspectionStatus'
export const FETCH_STATISTICS = 'fetchStatistics'
export const FETCH_LATEST_PROJECTS = 'fetchLatestProjects'
export const FETCH_LATEST_NOTIFICATIONS = 'fetchLatestNotifications'

// Mutations
export const STORE_SET_DISK_USAGE = 'storeSetDiskUsage'
export const STORE_SET_INSPECTION_STATUS = 'storeSetInspectionStatus'
export const STORE_SET_STATISTICS = 'storeSetStatistics'
export const STORE_SET_LATEST_PROJECTS = 'storeSetLatestProjects'
export const STORE_SET_LATEST_NOTIFICATIONS = 'storeSetLatestNotifications'

const state = {
	diskUsage: {
		amounts: {
			used: 0,
			total: 0,
		},
		percentages: {
			used: 0,
			free: 0,
		},
	},
	inspectionStatus: {
		amounts: {
			planned: 0,
			processing: 0,
			completed: 0,
		},
		percentages: [],
	},
	statistics: {
		projects: 0,
		objects: 0,
		inspections: 0,
		companies: 0,
	},
	latestProjects: [],
	latestNotifications: [],
}

const getters = {
	diskUsage (state) {
		return state.diskUsage
	},
	inspectionStatus (state) {
		return state.inspectionStatus
	},
	statistics (state) {
		return state.statistics
	},
	latestProjects (state) {
		return state.latestProjects
	},
	latestNotifications (state) {
		return state.latestNotifications
	},
}

const actions = {
	[FETCH_DISK_USAGE] (context) {
		return new Promise((resolve, reject) => {
			API.query('widgets/diskspace').then((response) => {
				context.commit(STORE_SET_DISK_USAGE, response.data)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_INSPECTION_STATUS] (context) {
		return new Promise((resolve, reject) => {
			API.query('widgets/inspection-status').then((response) => {
				context.commit(STORE_SET_INSPECTION_STATUS, response.data)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_STATISTICS] (context) {
		return new Promise((resolve, reject) => {
			API.query('widgets/statistics').then((response) => {
				context.commit(STORE_SET_STATISTICS, response.data)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_LATEST_PROJECTS] (context) {
		return new Promise((resolve, reject) => {
			API.query('widgets/latest-projects').then((response) => {
				context.commit(STORE_SET_LATEST_PROJECTS, response.data)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_LATEST_NOTIFICATIONS] (context) {
		return new Promise((resolve, reject) => {
			API.query('widgets/notifications').then((response) => {
				context.commit(STORE_SET_LATEST_NOTIFICATIONS, response.data)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
}

const mutations = {
	[STORE_SET_DISK_USAGE] (state, diskUsage) {
		state.diskUsage = diskUsage
	},
	[STORE_SET_INSPECTION_STATUS] (state, inspectionStatus) {
		state.inspectionStatus = inspectionStatus
	},
	[STORE_SET_STATISTICS] (state, statistics) {
		state.statistics = statistics
	},
	[STORE_SET_LATEST_PROJECTS] (state, projects) {
		state.latestProjects = projects;
	},
	[STORE_SET_LATEST_NOTIFICATIONS] (state, notifications) {
		state.latestNotifications = notifications;
	},
}

export default { state, getters, actions, mutations }